// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3524 ? "2170a4aa" : chunkId) + "." + {"3524":"02d9a64759bff447","6793":"f57464ca23fa9330","8436":"cab94b59cca0a8ff"}[chunkId] + ".js";
};